import _ from 'lodash';

const regexes = {
  alpha: /^[a-z]+(([-']|\s)?[a-z]+)*$/i,
  alphaSpecial:
    /^[a-z]+[!#%&'*+-/=?^_`{|}~]+(([-']|\s)?[a-z]+[!#%&'*+-/=?^_`{|}~]]+)*$/i,
  alphanumeric:
    /^((^[a-z]{2}\.\s)?((\w|\w')\s[a-z]{2}\.\s)?([a-z0-9]+-[a-z0-9]+)?(\/)?([a-z]{1}'[a-z]+|\s[a-z]{1}'[a-z]+|[a-z]'\s[a-z]+|[a-z]'[s]\s[a-z]+)*([a-z0-9]+\s{0,1})?)+(\w{2,}'|[\w]|\w{2,}'[s])$/i,
  alphanumericPunctuation: /^([a-z0-9\-_,./£$?!&:]*)$/i,
  addressLine1: /^([a-z0-9\-_, ./£$?!&:]*)$/i,
  currency: /^[0-9]*$/,
  date: /^((3[01]{1}|[012]{1}[0-9]{1})-((0[1-9]{1}|1[012]{1})))-((19[0-9]{2}|2[0-9]{3}))$/i,
  expirationDate: /^(0[1-9]{1}|1[012]{1})([1-9]{1}[0-9]{1})$/,
  email:
    /^([-a-z0-9~!$%^&*_/=+#`}{'?|]+(\.[-a-z0-9~!$%^&*_/=+#}{'?|]+)*)@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]+)$/i,
  number: /^[0-9]+$/,
  password:
    /^((?=.*\d)(?=.*[a-zA-Z])(?=.*['!"$%^&*()_\\\-/+={}[\]@‘~#?|<>,.;:])[a-zA-Z\d¬'!"£$%^&*()_\\\-/+={}[]@~#\?\|<>,.;:]{8,16})$/,
  phone: /(01)\d{9}|(02)\d{9}|(07)\d{9}/,
  mobilePhone: /^(07[\d]{9})$/,
  postcode:
    /^((GIR 0AA|X9 9RB|X9 9AA|X9 9BF|X9 9AJ|X9 9AB|X9 9TA|X9 9LG|X9 9BH|X9 9LF|X9 2TR|XE16 4QZ|XE11 1AA|XE98 1TL|XEP O11|XE99 3GG|XE0 2AQ|XE1A 1AA|XE18 3AN|XE7 4GJ|XE1P 2PR|XE2 7EJ|XE12 8JS|XE1H 9DW|XE 5GG|XE1X 7XA|XE1X 7XF|XE1 8NH|XE1 1RJ|XE1 1RN|XE1 1LE|XE24 99X|XE 0AA|XE12 8HJ)|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}))$/i,
  telephonePin:
    /^(?!(.)\1{3})(?!0123|1234|2345|3456|4567|5678|6789|7890|0987|9876|8765|7654|6543|5432|4321|3210)\d{4}$/,
  username: /^[a-zA-Z0-9]{6,16}$/,
  ntbusername: /^(?![\d]{10}$)([a-zA-Z0-9]{6,16})$/,
  accountName: "^[a-zA-Z0-9 ./'-]*$", // "/^(([a-z\_\,\.\?\!\&\:\$\£\&\:\/]+-[a-z\_\,\.\?\!\&\:\$\£\&\:\/]+)?([a-z]{1}\'[a-z\_\,\.\?\!\&\:\$\£\&\:\/]+|\s[a-z]{1}\'[a-z\_\,\.\?\!\&\:\$\£\&\:\/]+|[a-z0-9\_\,\.\?\!\&\:\$\£\&\:\/]\s[a-z\_\,\.\?\!\&\:\$\£\&\:\/]+|[a-z\_\,\.\?\!\&\:\$\£\&\:\/]\'[s]\s[a-z\_\,\.\?\!\&\:\$\£\&\:\/]+)*([a-z0-9\_\,\.\?\!\&\:\$\£\&\:\/]+\s{0,1})?)+([\w|\_\,\.\?\!\&\:\$\£\&\:\/\']{2,}|[\w]|[\w|\_\,\.\?\!\&\:\$\£\&\:\/\']{2,}\'[s])$/i,
  debitCardPan: /^([0-9]{5}|[0-9]{16}|[0-9]{19})$/,
  decimalNumber: /^\d+(\.{1,1})?(\d{1,2})?$/,
  numberDot: /^[0-9]|[.]/,
  timelineSearchData:
    '^([a-zA-Z0-9@&\\./= _\\?\\-:+\\;\\,\\(\\)Â£#\'"]{0,256})$',
  alphaSpace: /[a-zA-Z ]+.*|.*[a-zA-Z ]+|.*[a-zA-Z ]+.*/,
  amountRegex: '^[1-9]d*(.d+)?$',
  customTag: '^[a-zA-Z0-9 ]{1,16}$',
  alertEditProjection: /^[0-9]{0,6}(\.[0-9]{0,2})?$/,
  dateSlashFormat:
    /^((3[01]{1}|[012]{1}[0-9]{1})\/((0[1-9]{1}|1[012]{1})))\/((19[0-9]{2}|2[0-9]{3}))$/i,
  referenceRegex: /^[0-9A-Za-z-&./ ]{0,18}/,
  renameAccount: /^[A-Za-z-&'()%?@#\s\d$]{0,20}/,
  checkMultipleSpace: / {2,}/g,
  nicknameRegex: /^[0-9A-Za-z&()./ -]{0,50}/,
  poolNameRegex: /^[a-zA-Z0-9./\s-]+$/,
};

export default _.extend(
  {
    isValid(value, regexConstant) {
      const regExp = new RegExp(regexConstant);
      return regExp.test(value);
    },
  },
  { regexes }
);
